export default {"src":"/_next/static/media/ap-prep.cfce407e.svg","height":20,"width":19,"blurWidth":0,"blurHeight":0};